
/**
 * Google Translate
 * Load functionality only when user has clicked 
 */
jQuery(document).ready(function($) {

    // Add modal to DOM
    setup_google_translate_modal();

    // Activate upon click
    $('.translate-page-tool').click(function (e) {

        // Prevent default behavior
        e.preventDefault();

        // Object to identify if Google Translate is loaded
        var gt = (typeof default_tr != "undefined") 

        if(!gt) {

            // Load Google Translate
            $.getScript( "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit" ).done(function(script, textStatus) {
                
                // Toogle translate
                toggle_google_translate();

            }).fail(function( jqxhr, settings, exception ) {

                // Fail
                alert('translate.google.com failed to load.');
            });
        }
        else {

            //  Toogle translate
            toggle_google_translate();
        }
    });

    function toggle_google_translate() {

        var $modal = $('#gt-modal');

        if (!$modal.is(":visible")) {
            
            // Show modal
            $modal.show();
        }
        else {

            // Hide modal
            $modal.hide();
        }
    }

    function setup_google_translate_modal() {

        // Add modal to DOM
        $('body').append('<div id="gt-modal"><div id="gt-modal-close"><a href="#">Close</a></div><div id="google_translate_element"></div><p>Use Google to translate the web site. We take no responsibility for the accuracy of the translation.</p></div>');

        var l = 150;
        var t = 0;

        if ($(window).width() < 750)
            l = 0;

        l += $('.translate-page-tool').offset().left;
        t = $('.translate-page-tool').offset().top;

        $('#gt-modal').css({top: t, left: l});

        $('iframe.goog-te-menu-frame').contents().find('a').click(function (e) {
            $('#gt-modal').hide();
        });
    }

    // Enable modal hide
    $('#gt-modal-close').click(function (e) {
        e.preventDefault();
        $('#gt-modal').hide();
    });
});